import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Alarme, IAlarme } from '../../_models/Alarme';
import { Action, createAction, createFeatureSelector, createReducer, createSelector, on, props } from '@ngrx/store';

export const name = 'alarmes';

export interface AlarmeState extends EntityState<IAlarme> {
  selectedId: string | number | null;
  isInitialized: boolean;
  loading: boolean;
}

function selectAlarme(a: IAlarme): any {
  return a.id;
}

const adapter: EntityAdapter<IAlarme> = createEntityAdapter<IAlarme>({
  selectId: selectAlarme,
});

const initialState: AlarmeState = adapter.getInitialState({
  selectedId: null,
  isInitialized: false,
  loading: true,
});

/* ACTION */
export const loadAlarmesAction = createAction('[IAlarme] Load Alarmes');
export const loadAlarmesErrorAction = createAction('[IAlarme] Load Alarmes Error');
export const loadAlarmesSuccessAction = createAction('[IAlarme] Load Alarmes Success', props<{ payload: IAlarme[] }>());
export const setAlarmesAction = createAction('[IAlarme] Set alarmes', props<{ payload: IAlarme[] }>());

/* REDUCER */
const reducer = createReducer(
  initialState,
  on(loadAlarmesAction, (state) => {
    return { ...state, isInitialized: false, loading: true };
  }),
  on(loadAlarmesErrorAction, (state) => {
    return { ...state, loading: false };
  }),
  on(loadAlarmesSuccessAction, (state, { payload }) => {
    if (!Array.isArray(payload)) {
      return { ...state, isInitialized: true, loading: false };
    }
    return adapter.setAll(payload, {
      ...state,
      isInitialized: true,
      loading: false,
    });
  }),
  on(setAlarmesAction, (state, { payload }) => {
    return adapter.setAll(payload, state);
  })
);

export function alarmeReducer(state: AlarmeState | undefined, action: Action): AlarmeState {
  return reducer(state, action);
}

/* SELECTOR */
const selectAlarmeState = createFeatureSelector<AlarmeState>(name);

const isInitialized = (state: AlarmeState) => state.isInitialized;
const isLoading = (state: AlarmeState) => state.loading;
export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllAlarmes = createSelector(selectAlarmeState, (state) => {
  return state.loading ? undefined : state.ids.map((id: any) => new Alarme(state.entities[id]));
});
export const getIsAlarmeInitialized = createSelector(selectAlarmeState, isInitialized);
export const getIsAlarmeLoading = createSelector(selectAlarmeState, isLoading);

export const getAlarmesWithHighCriticity = createSelector(selectAllAlarmes, (alarmes) => {
  const nouvelle = alarmes ? alarmes.filter((a) => a.idEtat === 1) : [];
  const acquittee = alarmes ? alarmes.filter((a) => a.idEtat === 3) : [];
  return {
    totalNouvelle: nouvelle.length,
    totalAcquitte: acquittee.length,
  };
});
